import { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

// Local, display-only password visibility toggle. Never alters stored/submitted
// value; only switches the input's rendered type in the browser.
export const PasswordInput = forwardRef(function PasswordInput(
  { className, testid = "password-input", toggleTestid, ...props }, ref) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        ref={ref}
        type={show ? "text" : "password"}
        data-testid={testid}
        className={cn("pr-11", className)}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={0}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        data-testid={toggleTestid || `${testid}-toggle`}
        className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-slate-500 transition-colors hover:text-slate-300 focus:text-blue-400 focus:outline-none"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
